
<div *ngIf="navItems.length > 0" fxLayout="row" class="mb-3"
    fxLayoutAlign="">
    <div class="flex flex-row align-items-center surface-400 border-1 border-100 border-round-xl">
        <label class="font-semibold ml-3">{{ 'CONNECTED_TO' | translate }} : </label>
        <app-breadcrumb [items]="navItems"></app-breadcrumb>
        <p-breadcrumb styleClass="border-none" [model]="navItems" [home]="home"></p-breadcrumb>
    </div>
</div>
<app-device-info></app-device-info>